export function createSimpleReducer<T>(defaultState: T) {
  return (state: T = defaultState) => state;
}
